import { useState, type FormEvent } from "react";
import { Check, Loader2 } from "lucide-react";
import { submitDemoRequest } from "../lib/supabase";

const businessTypes = [
  "Institut de beauté",
  "Salon de coiffure",
  "Épicerie",
  "Restauration rapide",
  "Buffet à volonté",
  "Autre",
];

type Status = "idle" | "submitting" | "success" | "error";

const inputClass =
  "w-full rounded-xl border border-line bg-white px-4 py-3 text-sm text-ink placeholder:text-ink-soft/60 focus:border-coral focus:outline-none focus:ring-2 focus:ring-coral/20";

export function DemoForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [businessName, setBusinessName] = useState("");
  const [businessType, setBusinessType] = useState(businessTypes[0]);
  const [contactName, setContactName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setStatus("submitting");
    try {
      await submitDemoRequest({
        businessName,
        businessType,
        contactName,
        email,
        phone,
        message: "",
      });
      setStatus("success");
    } catch {
      setStatus("error");
    }
  }

  if (status === "success") {
    return (
      <div className="mx-auto flex max-w-md flex-col items-center gap-3 rounded-2xl border border-mint/30 bg-mint/5 px-6 py-8 text-center">
        <div className="flex h-11 w-11 items-center justify-center rounded-full bg-mint text-white">
          <Check size={22} />
        </div>
        <p className="font-bold text-ink">Demande envoyée !</p>
        <p className="text-sm text-ink-soft">
          On revient vers vous très vite pour organiser votre démo.
        </p>
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="mx-auto flex max-w-md flex-col gap-3 text-left"
    >
      <input
        required
        placeholder="Nom du commerce"
        value={businessName}
        onChange={(e) => setBusinessName(e.target.value)}
        className={inputClass}
      />
      <select
        aria-label="Type de commerce"
        value={businessType}
        onChange={(e) => setBusinessType(e.target.value)}
        className={inputClass}
      >
        {businessTypes.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>
      <input
        required
        placeholder="Votre nom"
        value={contactName}
        onChange={(e) => setContactName(e.target.value)}
        className={inputClass}
      />
      <input
        required
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className={inputClass}
      />
      <input
        required
        type="tel"
        placeholder="Téléphone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        className={inputClass}
      />

      <button
        type="submit"
        disabled={status === "submitting"}
        className="mt-1 flex items-center justify-center gap-2 rounded-full bg-ink px-8 py-4 text-sm font-semibold text-white shadow-soft transition-transform hover:scale-[1.02] disabled:opacity-60 disabled:hover:scale-100"
      >
        {status === "submitting" ? (
          <>
            <Loader2 size={16} className="animate-spin" /> Envoi...
          </>
        ) : (
          "Réserver une démo gratuite →"
        )}
      </button>

      {status === "error" && (
        <p className="text-center text-sm text-coral">
          Un problème est survenu — réessayez, ou écrivez-nous directement à{" "}
          <a href="mailto:contact@fidelo.com" className="underline">
            contact@fidelo.com
          </a>
          .
        </p>
      )}
    </form>
  );
}
